// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import TextareaAutosize from '@fulcrumapp/react-textarea-autosize';
import cx from 'classnames';
import ElementView from './base/element-view';
import THEME from '../../shared/theme';

export default class TextElementView extends ElementView {
  static propTypes = {
    ...ElementView.propTypes,
    onFocusChange: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      textValue: props.value.textValue || '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ textValue: nextProps.value.textValue || '' });
  }

  renderEditable() {
    if (this.props.element.isNumeric) {
      return this.renderNumericField();
    }

    return this.renderTextField();
  }

  renderTextField() {
    const { styles } = TextElementView;

    return (
      <TextareaAutosize
        useCacheForDOMMeasurements
        minRows={1}
        value={this.state.textValue}
        onChange={this.handleChange}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        disabled={this.props.disabled}
        className={styles.default}
      />
    );
  }

  renderNumericField() {
    const { styles } = TextElementView;

    return (
      <input
        type="number"
        step="any"
        className={css(styles.default)}
        disabled={this.props.disabled}
        min={this.props.element.min}
        max={this.props.element.max}
        value={this.state.textValue}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
      />
    );
  }

  handleBlur = (event) => {
    if (this.props.onFocusChange) {
      this.props.onFocusChange(this, false);
    }
  };

  handleFocus = (event) => {
    if (this.props.onFocusChange) {
      this.props.onFocusChange(this, true);
    }
  };

  handleChange = (event) => {
    const { value } = event.target;

    this.setState({ textValue: value });

    this.props.value.textValue = value;
    this.props.onChange(this.props.value);
  };
}

const styles = cssInJS({
  default: {
    marginTop: 4,
    border: '1px solid #d9d9d9',
    padding: 4,
    width: '100%',
    borderRadius: 5,
    fontSize: THEME.editFontSize,
    fontFamily: THEME.fontFamily,
    marginBottom: 0,
    overflow: 'hidden',

    '@phone': {
      border: 'none',
      padding: 6,
    },
  },
});

TextElementView.styles = styles;
